import { filter } from "lodash";
import axios from "axios";
import {
  storageUrl,
  CategoriesUrl,
  apiKey,
  productsUrl,
} from "../constants/urls";

/* import { sentenceCase } from "change-case"; */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// material
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Box,
  TextField,
  Select,
  InputLabel,
  MenuItem,
  OutlinedInput,
  LinearProgress,
  Avatar,
} from "@mui/material";

// components

import Page from "../components/Page";
import Scrollbar from "../components/Scrollbar";
import SearchNotFound from "../components/SearchNotFound";
import { UserListHead, UserListToolbar } from "../sections/@dashboard/user";
import { useTranslation } from "react-i18next";
import { LoadingButton } from "@mui/lab";
import Swal from "sweetalert2";
import ProductsMoreMenu from "../sections/@dashboard/user/ProductsMoreMenu";
//

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export default function Products() {
  const { t, i18n } = useTranslation();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState("name");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [openNewUser, setOpenNewUser] = useState(false);
  const [loadingUserBtn, setLoadingUserBtn] = useState(false);
  const [EnName, setEnName] = useState();
  const [ArName, setArName] = useState();
  const [KuName, setKuName] = useState();
  const [EnDesc, setEnDesc] = useState();
  const [ArDesc, setArDesc] = useState();
  const [KuDesc, setKuDesc] = useState();
  const [Price, setPrice] = useState();
  const [Cat_id, setCat_id] = useState();
  const [Sort, setSort] = useState();
  const [previewUserImage, setPreviewUserImage] = useState(null);
  const [UserImageToUpload, setUserImageToUpload] = useState(null);

  const [Products, setProducts] = useState();
  const [ProductsToShow, setProductsToShow] = useState();
  const [Categories, setCategories] = useState();
  const [filterCategory, setFilterCategory] = useState();

  let navigate = useNavigate();
  const token = localStorage.getItem("Ftkn");
  async function fecthData() {
    if (token === null) {
      navigate("/");
    } else {
      await axios
        .get(`${productsUrl}`, {
          headers: {
            Authorization: "Bearer " + token,
            Accept: "application/json",
            api_key: apiKey,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setProducts(response.data);
            setProductsToShow(response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  async function fecthCategories() {
    await axios
      .get(`${CategoriesUrl}`, {
        headers: {
          Authorization: "Bearer " + token,
          Accept: "application/json",
          api_key: apiKey,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setCategories(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    fecthData();
    fecthCategories();
  }, [loadingUserBtn]);

  if (
    Products === undefined ||
    Categories === undefined ||
    ProductsToShow === undefined
  ) {
    return <LinearProgress />;
  }
  let filteredUsers = applySortFilter(
    ProductsToShow,
    getComparator(order, orderBy),
    filterName
  );

  const TABLE_HEAD = [
    {
      id: "name",
      label: "Product Name",
      alignRight: false,
    },
    {
      id: "category_name",
      label: "Category Name",
      alignRight: false,
    },
    {
      id: "price",
      label: "Price",
      alignRight: false,
    },
    {
      id: "sort",
      label: "Sort",
      alignRight: false,
    },
    {
      id: "description",
      label: "Description",
      alignRight: false,
    },
    { id: "" },
  ];

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = ProductsToShow.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - ProductsToShow.length)
      : 0;

  function applySortFilter(array, comparator, query) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    if (query) {
      return filter(
        array,
        (element) =>
          element.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
      );
    }
    return stabilizedThis.map((el) => el[0]);
  }

  const isUserNotFound = filteredUsers.length === 0;

  const handleChangeEnName = (event) => {
    setEnName(event.target.value);
  };

  const handleChangeArName = (event) => {
    setArName(event.target.value);
  };

  const handleChangeKuName = (event) => {
    setKuName(event.target.value);
  };

  const handleChangeEnDesc = (event) => {
    setEnDesc(event.target.value);
  };

  const handleChangeArDesc = (event) => {
    setArDesc(event.target.value);
  };

  const handleChangeKuDesc = (event) => {
    setKuDesc(event.target.value);
  };

  const handleChangeCatId = (event) => {
    setCat_id(event.target.value);
  };

  const handleChangePrice = (event) => {
    setPrice(event.target.value);
  };

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const handleClickOpenNewUser = () => {
    setOpenNewUser(true);
  };

  const handleCloseNewUser = () => {
    setOpenNewUser(false);
  };

  const handleChangeFilterCategory = (event) => {
    if (event.target.value === "All Categories") {
      setProductsToShow(Products);
    } else {
      setProductsToShow(
        Products.filter((item) => item.category_id === event.target.value)
      );
    }
  };

  const handleCaptureUserImage = (e) => {
    setUserImageToUpload(e.target.files[0]);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setPreviewUserImage(reader.result);
      }
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const handleSubmitAddUser = () => {
    setLoadingUserBtn(true);
    const formData = new FormData();
    formData.append("code", EnName);
    formData.append("name[en]", EnName);
    formData.append("name[ar]", ArName);
    formData.append("name[ku]", KuName);
    formData.append("description[en]", EnDesc);
    formData.append("description[ar]", ArDesc);
    formData.append("description[ku]", KuDesc);
    formData.append("price", Price);
    formData.append("category_id", Cat_id);
    formData.append("currency_id", 3);
    formData.append("sort", Sort);
    UserImageToUpload !== null && formData.append("image", UserImageToUpload);

    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
      api_key: apiKey,
    };
    axios
      .post(`${productsUrl}`, formData, {
        headers,
      })
      .then((response) => {
        setLoadingUserBtn(false);
        setOpenNewUser(false);
        setEnName("");
        setArName("");
        setKuName("");
        setEnDesc("");
        setArDesc("");
        setKuDesc("");
        setPrice("");
        setCat_id("");
        setSort("");

        setPreviewUserImage(null);
        setUserImageToUpload(null);
        Swal.fire({
          text: "Product Added Successfully!",
          icon: "success",
        }).then((result) => {
          if (result.isConfirmed) {
            setLoadingUserBtn(false);
          }
        });
      })
      .catch((error) => {
        setLoadingUserBtn(false);
        setOpenNewUser(false);
        Swal.fire({
          icon: "error",
          text: error.response.data.message,
        });
      });
  };

  return (
    <Page title="Dashboard | products">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Products
          </Typography>
          <Button variant="contained" onClick={handleClickOpenNewUser}>
            Add New
          </Button>
        </Stack>
        <Dialog
          disableEscapeKeyDown
          open={openNewUser}
          onClose={handleCloseNewUser}
        >
          <DialogTitle>Add new product</DialogTitle>
          <DialogContent sx={{ width: "100%" }}>
            <Box component="form">
              <FormControl sx={{ m: 1, minWidth: 350 }}>
                <TextField
                  id="outlined-basic"
                  label="English name"
                  variant="outlined"
                  onChange={handleChangeEnName}
                  value={EnName}
                />
              </FormControl>
            </Box>
            <Box component="form">
              <FormControl sx={{ m: 1, minWidth: 350 }}>
                <TextField
                  id="outlined-basic"
                  label="Arabic name"
                  variant="outlined"
                  type={"text"}
                  onChange={handleChangeArName}
                  value={ArName}
                />
              </FormControl>
            </Box>
            <Box
              component="form"
              sx={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <FormControl sx={{ m: 1, minWidth: 350 }}>
                <TextField
                  id="outlined-basic"
                  label="Kurdish name"
                  variant="outlined"
                  type={"text"}
                  onChange={handleChangeKuName}
                  value={KuName}
                />
              </FormControl>
            </Box>
            <Box component="form">
              <FormControl sx={{ m: 1, minWidth: 350 }}>
                <TextField
                  id="outlined-basic"
                  label="English Description"
                  variant="outlined"
                  type="text"
                  multiline
                  rows={4}
                  onChange={handleChangeEnDesc}
                  value={EnDesc}
                />
              </FormControl>
            </Box>
            <Box component="form">
              <FormControl sx={{ m: 1, minWidth: 350 }}>
                <TextField
                  id="outlined-basic"
                  label="Arabic Description"
                  variant="outlined"
                  type="text"
                  multiline
                  rows={4}
                  onChange={handleChangeArDesc}
                  value={ArDesc}
                />
              </FormControl>
            </Box>
            <Box component="form">
              <FormControl sx={{ m: 1, minWidth: 350 }}>
                <TextField
                  id="outlined-basic"
                  label="Kurdish Description"
                  variant="outlined"
                  type="text"
                  multiline
                  rows={4}
                  onChange={handleChangeKuDesc}
                  value={KuDesc}
                />
              </FormControl>
            </Box>
            <Box component="form">
              <FormControl sx={{ m: 1, minWidth: 350 }}>
                <TextField
                  id="outlined-basic"
                  label="Price"
                  variant="outlined"
                  type="number"
                  onChange={handleChangePrice}
                  value={Price}
                />
              </FormControl>
            </Box>
            <Box component="form">
              <FormControl sx={{ m: 1, minWidth: 350 }}>
                <TextField
                  id="outlined-basic"
                  label="Sort"
                  variant="outlined"
                  type="number"
                  onChange={handleChangeSort}
                  value={Sort}
                />
              </FormControl>
            </Box>
            <Box
              component="form"
              sx={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <FormControl sx={{ m: 1, minWidth: 350 }}>
                <InputLabel id="demo-dialog-select-label">Category</InputLabel>
                <Select
                  labelId="demo-dialog-select-label"
                  id="demo-dialog-select"
                  value={Cat_id}
                  onChange={handleChangeCatId}
                  input={<OutlinedInput label="Category" />}
                >
                  {Categories.map((item) => (
                    <MenuItem value={item.id} key={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <Box
              component="form"
              sx={{
                display: "flex",
                flexDirection: "column",
                flexWrap: "nowrap",
                width: "90%",
                marginTop: "1rem",
              }}
            >
              <Typography>Product Image</Typography>
              <FormControl sx={{ m: 1, maxWidth: "100%" }}>
                <Box className="upload__image-wrapper">
                  {previewUserImage ? (
                    <Box className="image-item">
                      <Avatar
                        src={`${previewUserImage}`}
                        alt=""
                        sx={{ width: 200, height: 200, margin: "0 auto" }}
                      />
                      <Box className="image-item__btn-wrapper">
                        <Button
                          sx={{ margin: "1rem 0" }}
                          variant="outlined"
                          onClick={() => setPreviewUserImage(null)}
                        >
                          Remove{" "}
                        </Button>
                      </Box>
                    </Box>
                  ) : (
                    <Button
                      sx={{ margin: "1rem 0" }}
                      variant="outlined"
                      component="label"
                    >
                      Upload Product Image
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={handleCaptureUserImage}
                      />
                    </Button>
                  )}
                </Box>
              </FormControl>
            </Box>
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center" }}>
            <Button onClick={handleCloseNewUser}>
              {t("description.Cancel")}
            </Button>
            <LoadingButton
              loading={loadingUserBtn}
              onClick={handleSubmitAddUser}
            >
              {t("description.Ok")}
            </LoadingButton>
          </DialogActions>
        </Dialog>
        <Card>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <UserListToolbar
              placeHolder="Search by name ..."
              numSelected={selected.length}
              filterName={filterName}
              onFilterName={handleFilterByName}
            />
            <Box
              component="form"
              sx={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              <FormControl sx={{ m: 1, minWidth: 350 }}>
                <InputLabel id="demo-dialog-select-label">Category</InputLabel>
                <Select
                  labelId="demo-dialog-select-label"
                  id="demo-dialog-select"
                  value={filterCategory}
                  onChange={handleChangeFilterCategory}
                  input={<OutlinedInput label="Category" />}
                >
                  <MenuItem value={"All Categories"}>All Categories</MenuItem>
                  {Categories.map((item) => (
                    <MenuItem value={item.id} key={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <UserListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={ProductsToShow.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => {
                      const { id, name } = row;
                      const isItemSelected = selected.indexOf(row.name) !== -1;
                      return (
                        <TableRow
                          hover
                          key={id}
                          tabIndex={-1}
                          role="checkbox"
                          selected={isItemSelected}
                          aria-checked={isItemSelected}
                        >
                          <TableCell component="th" scope="row">
                            <Stack
                              direction="row"
                              alignItems="center"
                              spacing={2}
                            >
                              <Avatar
                                alt={name}
                                src={`${storageUrl}${row.media[0]}`}
                                sx={{ width: "80px", height: "80px" }}
                              />
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  margin:
                                    i18n.dir() === "rtl" &&
                                    "0 0.5rem !important",
                                  width: "150px",
                                }}
                              >
                                {name}
                              </Typography>
                            </Stack>
                          </TableCell>
                          <TableCell
                            align={i18n.dir() === "ltr" ? "left" : "right"}
                          >
                            {Categories.map((item) => {
                              if (item.id === row.category_id) {
                                return item.name;
                              }
                            })}
                          </TableCell>
                          <TableCell
                            align={i18n.dir() === "ltr" ? "left" : "right"}
                          >
                            {row.price} IQD
                          </TableCell>
                          <TableCell
                            align={i18n.dir() === "ltr" ? "left" : "right"}
                          >
                            {row.sort}
                          </TableCell>
                          <TableCell
                            align={i18n.dir() === "ltr" ? "left" : "right"}
                          >
                            {row.description.slice(0, 30)}...
                          </TableCell>
                          <TableCell
                            align={i18n.dir() === "ltr" ? "right" : "left"}
                            padding="none"
                          >
                            <ProductsMoreMenu
                              item={row}
                              token={token}
                              loadingUserBtn={loadingUserBtn}
                              setLoadingUserBtn={setLoadingUserBtn}
                              apiKey={apiKey}
                              Categories={Categories}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>
                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            sx={{ direction: "ltr" }}
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={ProductsToShow.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage={t("description.UsersPageLabelRowsPerPage")}
          />
        </Card>
      </Container>
    </Page>
  );
}
